<script>
import BaseListing from './Listing'

export default {
  mixins: [
    BaseListing
  ],
  data () {
    return {
      headerTitle: { title: 'Role: Ford', description: 'Lista' },
      service: this.$route.meta.acl.service,
      actionShowUrlName: '',
      gridName: 'grid_role',
      gridColumns: this.$route.meta.columns
    }
  },
  computed: {
    gridActions () {
      return [
        { id: 0, event: 'show', title: 'Szczegóły', icon: 'eye', acl: { service: this.service, action: 'get_role' } }
      ]
    }
  },
  created () {
    this.getInitActionShowUrlName()
  },
  methods: {
    getInitActionShowUrlName () {
      this.actionShowUrlName = `${this.service}_role_details`
    }
  }
}
</script>
